<script setup lang="ts">
import { v4 as uuidv4 } from "uuid";

defineProps({
  value: {
    type: Number,
    required: true
  },
  name: {
    type: String,
    default: ""
  },
  id: {
    type: String,
    default: uuidv4()
  },
  text: {
    type: String,
    default: ""
  },
  checked: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(["change"]);

const onChange = (e: Event) => {
  if (!(e.target instanceof HTMLInputElement)) {
    return;
  }
  emit("change", e.target.value);
};
</script>

<template>
  <div class="work-type-radio">
    <input
      type="radio"
      :name="name"
      :value="value"
      :id="id"
      class="work-type-radio-input"
      :checked="checked"
      @change="onChange"
    />
    <label :for="id" class="work-type-radio-label">{{ text }}</label>
  </div>
</template>

<style lang="scss" scoped>
.work-type-radio {
  & .work-type-radio-input {
    display: none;

    &:checked + .work-type-radio-label {
      background: #fff8e1;
      border: 1px solid #fbce5a;
      border-radius: 4px;

      &::before {
        background: $blue;
        border: 1px solid #fbce5a;
      }

      &::after {
        opacity: 1;
      }
    }
  }

  & .work-type-radio-label {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 12px 8px 44px;
    margin-bottom: 0;
    font-family: "Noto Sans JP", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.79px;
    color: #31373f;
    border: 1px solid #e5e5e5;
    border-radius: 4px;

    &::before,
    &::after {
      position: absolute;
      display: block;
      content: "";
      border-radius: 50%;
    }

    &::before {
      left: 12px;
      width: 24px;
      height: 24px;
      border: 1px solid #e5e5e5;
    }

    &::after {
      left: 20px;
      width: 8px;
      height: 8px;
      background: #fff;
      opacity: 0;
    }
  }
}
</style>
